import { TableExtraPay } from "../../../dispatch/src/TableExtraPay";
import { DataSource, Image, Label, Layout, Panel, StarRating, Step, Stepper, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMultiCarrierAssignmentStepper extends Layout {
    carrierAssignmentStep: Step;
    dfLabel: Label;
    imageCarrierVerification: Image;
    labelAssignmentTitle: Label;
    labelErrorCount: Label;
    labelErrors: Label;
    labelSubtitle: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    layoutTableExtraPay: TableExtraPay;
    panelCarrierInformation: Panel;
    panelContact: Panel;
    panelCounts: Panel;
    panelHeader: Panel;
    panelRates: Panel;
    panelReady: Panel;
    panelTotal: Panel;
    sourceCarrier: DataSource;
    sourceCarriersForAssignment: DataSource;
    sourceExtraPay: DataSource;
    sourceMovement: DataSource;
    sourceMultiCarrierValidator: DataSource;
    starratingScorecard: StarRating;
    stepperMultiAssignment: Stepper;
    tabPayAdjustment: Tab;
    tableMultiAssignment: Table;
    tabsetPayAdjustments: Tabset;
    textboxCarrierInital: Textbox;
    textboxContactinital: Textbox;
    textboxCurrencyCodeSelector: Textbox;
    textboxEmail: Textbox;
    textboxOverridePayRate: Textbox;
    textboxOverrideType: Textbox;
    textboxPhone: Textbox;
}
